import { apiConfig } from '../config/backend-api';
import axios from 'axios';
import { store } from '../store';
import { userData } from '../models/user';

export const adminService = {
  createUser,
  updateUser,
  deleteUser,
  getUsers,
  forgotPassword,
  resetPassword,
  getServices,
  downloadInstaller,
  cancelDownload,
  updateService,
  deleteService,
  getGroupMembers,
  updateGroupMembers,
  updateAdminProfile,
  getProfile,
//  checkTrialExpiration,
  changePassword,
  pingServices,
  getCheckoutSession,
  getCustomerPortalSession,
  reset2FA,
  setUserTour,
  getUserData,
  refreshUserData,
  parseUserData,
  getOneTimeUrl,
  headerWithToken,
  updateAccountInformation,
  deleteAccount
};

let downloadToken = null;

function headerWithToken() {
  let token = '';
  if (store.state.auth.user) {
    token = store.state.auth.token ?? token;
  }
  let headers = {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${token}`,
  };
  return headers;
}

async function downloadInstaller(refressFunc) {
  downloadToken = axios.CancelToken.source();
  return await axios({
    url: apiConfig.downloadUrl,
    // TODO: url final
    method: 'GET',
    ajaxState: false,
    cancelToken: downloadToken.token,
    responseType: 'blob',
    onDownloadProgress: (progressEvent) => {
      const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      refressFunc(percentage);
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', apiConfig.downloadUrl.substring(apiConfig.downloadUrl.lastIndexOf('/')+1));
    document.body.appendChild(anchor);
    anchor.click();
  });
}

function cancelDownload() {
  if (downloadToken !== null) {
    downloadToken.cancel('Operation canceled by the user.');
  }
}

function forgotPassword(accountId, email) {
  return axios.post(
    `${apiConfig.baseUrl}/auth/forgotpassword`,
    { accountId, email },
    { headers: headerWithToken() }
  );
}

function getOneTimeUrl(asAdmin, { config = {} } = {}) {
  return axios.post(
    `${apiConfig.baseUrl}/auth/oturl`,
    ((asAdmin) ? {'webadmin': true } : {} ),
    { headers: headerWithToken(), ...(config?.ajaxOptions ?? {}) }
  );
}

function resetPassword(usertoken, password) {
  return axios.post(
    `${apiConfig.baseUrl}/auth/resetpassword`,
    { usertoken, password },
    { headers: headerWithToken() }
  );
}

function changePassword(currentPassword, newPassword) {
  return axios.post(
    `${apiConfig.baseUrl}/auth/changepassword`,
    { newPassword: newPassword, oldPassword: currentPassword },
    { headers: headerWithToken() }
  );
}

function createUser(user) {
  user.accountId = store.state.auth.user.accountId;
  return axios.post(`${apiConfig.baseUrl}/users/`, user, {
    headers: headerWithToken(),
  });
}

function updateUser(user) {
  return axios.put(`${apiConfig.baseUrl}/users/`, user, {
    headers: headerWithToken(),
  });
}

function deleteUser(userId) {
  return axios.delete(`${apiConfig.baseUrl}/users/${userId}`, {
    headers: headerWithToken(),
  });
}

function getUsers({ config = {} } = {}) {
  return axios.get(`${apiConfig.baseUrl}/users/`, {
    headers: headerWithToken(),
    ...(config?.ajaxOptions ?? {})
  });
}

function getServices(serviceId, { config = {} } = {}) {
  let url;
  if (serviceId == null) {
    url = `${apiConfig.baseUrl}/services/`;
  } else {
    url = `${apiConfig.baseUrl}/services/${serviceId}`;
  }
  return axios.get(url, { headers: headerWithToken(), ...(config?.ajaxOptions ?? {}) });
}

function updateService(serviceIsDown, service, members) {
  let updateservice = { serviceIsDown, service: service, members: members};
  let url = `${apiConfig.baseUrl}/services/${service.id}`;
  return axios.put(url, updateservice, { headers: headerWithToken() });
}

function deleteService(serviceId) {
  let url = `${apiConfig.baseUrl}/services/${serviceId}`;
  return axios.delete(url, { headers: headerWithToken() });
}

function getGroupMembers(groupId){
  let url = `${apiConfig.baseUrl}/groups/${groupId}/members`;
  return axios.get(url, { headers: headerWithToken() });
}

function updateGroupMembers(groupId, members) {
  let url = `${apiConfig.baseUrl}/groups/${groupId}/members`;
  return axios.post(url, { members: members }, { headers: headerWithToken() });
}

function updateAdminProfile(user) {
  user.userId = store.state.auth.user.email;
  return axios.put(`${apiConfig.baseUrl}/admin/profile`, user, {
    headers: headerWithToken(),
  });
}

/*function pingService(url, { config = {} } = {}) {
  let headers = { 'Content-Type': 'application/json' };
  return axios.get(url + '/ping', {
    headers: headers,
    ...(config?.ajaxOptions ?? {})
  });
}
*/

function pingServices({ config = {} } = {}) {
  let url = `${apiConfig.baseUrl}/services/ping`;
  return axios({ method: "PROPFIND", url: url, headers: headerWithToken(), ...(config?.ajaxOptions ?? {}) });
}

function getProfile() {
  let url = `${apiConfig.baseUrl}/admin/profile`;
  return axios.get(url, {
    headers: headerWithToken(),
  });
}

async function deleteAccount({token}) {
  return axios.delete(
    `${apiConfig.baseUrl}/account`,
    { data: { reCaptchaToken: token }, headers: headerWithToken() }
  );
}

/*function checkTrialExpiration() {
  let url = `${apiConfig.baseUrl}/admin/checktrialexpiration`;
  axios
    .get(url, {
      headers: headerWithToken(),
    })
    .then((response) => {
      let r = { response };
      store.commit('trialExpired', r.response.data.data.trialexpires);
    })
    .catch(() => {
      store.commit('trialExpired', true);
    });
}
*/

function getCheckoutSession(priceid, customerMode) {
  return axios.get(
    `${apiConfig.baseUrl}/stripe/checkout/createsession/${priceid}/${customerMode}`,
    {
      headers: headerWithToken(),
    }
  );
}

function getCustomerPortalSession() {
  return axios.get(`${apiConfig.baseUrl}/stripe/portal/createsession/`, {
    headers: headerWithToken(),
  });
}

function reset2FA(serviceId, emailOrUserId) {
  return axios.post(
    `${apiConfig.baseUrl}/auth/reset2fa/${serviceId}`,
    { email: emailOrUserId },
    { headers: headerWithToken() }
  );
}

function setUserTour(val = true, { config = {} } = {}) {
  return axios
    .put(
      `${apiConfig.baseUrl}/users/`,
      { email: store.state.auth.user.email, endTour: val },
      { headers: headerWithToken(), ...(config?.ajaxOptions ?? {}) }
    )
    .then(() => {
      localStorage.setItem('thinfinity.workspaces.endTour', val);
      store.state.auth.user.endTour = val;
    });
}

function parseUserData(res) {
  return {
    ...userData,
    accountId: res.accountid,
    email: res.email,
    lastName: res.user.lastName,
    firstName: res.user.firstName,
    role: res.level,
    endTour: !res.user.endTour === false || localStorage.getItem('thinfinity.workspaces.endTour') === "true"
  };
}

async function refreshUserData() {
  let user = await getUserData();
  let account = user?.data?.data.user.account;
  user = await user?.data?.data;
  if (user) {
    user = parseUserData(user);
    store.dispatch('userData', { user, account, token: store.state.auth?.token });
  } else {
    throw new Error(400);
  }
}

function getUserData({ config = {} } = {}) {
  return axios.get( `${apiConfig.baseUrl}/auth/userdata`, {
    headers: headerWithToken(),
    ...(config?.ajaxOptions ?? {})
  });
}

function updateAccountInformation(accountInformation, { config = {} } = {}) {
  return axios.put(`${apiConfig.baseUrl}/account/`, accountInformation, {
    headers: headerWithToken(),
    ...(config?.ajaxOptions ?? {})
  });
}